import { keyBy } from 'lodash/fp'

export const statusLabels = {
  PENDING: 'Nieprzeprowadzone',
  DONE: 'Przeprowadzone',
}

export const disabilityOptions = [
  { value: 'None', label: 'Grupa ogólna' },
  {
    value: 'IntellectualNotable',
    label:
      // eslint-disable-next-line max-len
      'niepełnosprawność intelektualna w stopniu umiarkowanym, znacznym i głębokim',
  },
  {
    value: 'IntellectualSlight',
    label: 'niepełnosprawność intelektualna w stopniu lekkim',
  },
  {
    value: 'AutismSpectrum',
    label: 'zaburzenie ze spektrum autyzmu',
  },
  { value: 'SightNotable', label: 'dysfunkcja wzroku – słabowidzący' },
  { value: 'SightBlind', label: 'dysfunkcja wzroku – niewidzący' },
  {
    value: 'FunctionalHearing',
    label: 'dysfunkcja słuchu – funkcjonalnie słyszący',
  },
  { value: 'Deaf', label: 'dysfunkcja słuchu – niesłyszący' },
  { value: 'Linguistic', label: 'zaburzenia komunikacji językowej' },
  { value: 'Dyslexic', label: 'dysleksja' },
  { value: 'ADHD', label: 'ADHD' },
  {
    value: 'Outstanding',
    label: 'ponadprzeciętny potencjał poznawczy',
  },
  { value: 'Bilingual', label: 'osoby z doświadczeniem migracji' },
]

export const disabilityByValue = keyBy('value', disabilityOptions)
